export const getLocationInsurances = (location) => {
  let insurances = [];

  if (
    location &&
    location?.city &&
    location?.city?.country &&
    location?.city?.country?.insurances
  )
    insurances = location?.city?.country?.insurances;

  return insurances;
};

export const getSelectedInsurances = (insurances) =>
  insurances && insurances.filter((insurance) => insurance.selected);

export const getSelectedInsurancesIds = (insurances) => {
  const insuranceArray = [];

  insurances.forEach((a) => {
    if (a.selected || a.required) insuranceArray.push({ id: a.id });
  });

  return insuranceArray;
};

export const insuranceQuoteBreadcrumb = (hash, abroadName) => [
  {
    href: '/account',
    text: 'Minha conta',
    type: 'link',
  },
  {
    href: `/account/abroad/${hash}`,
    text: `${abroadName}`,
    type: 'link',
  },
  {
    text: 'Confirmação',
  },
];
